function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import Icon from '../Icon';
import './style.less';

var Tag = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Tag, _KZUIComponent);

  var _super = _createSuper(Tag);

  function Tag() {
    _classCallCheck(this, Tag);

    return _super.apply(this, arguments);
  }

  _createClass(Tag, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      this.autoBind('handleRemove', 'handleClick');
      return {
        cur: props.active
      };
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.props.onChange) {
        this.props.onChange({
          value: this.props.value,
          label: this.props.label
        });
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(event) {
      if (this.props.removeAble && this.props.onRemove) {
        this.props.onRemove({
          value: this.props.value,
          label: this.props.label
        });
      }

      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-tag'; // TODO removeAble 命名有问题

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          multi = _this$props.multi,
          disabled = _this$props.disabled,
          showOnly = _this$props.showOnly,
          removeAble = _this$props.removeAble,
          label = _this$props.label;
      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-active"), this.state.cur), _defineProperty(_classNames, "".concat(clsPrefix, "-multi"), multi), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-showOnly"), showOnly), _defineProperty(_classNames, "".concat(clsPrefix, "-removeAble"), removeAble), _classNames), className);
      return /*#__PURE__*/React.createElement("span", {
        className: cls,
        style: style,
        onClick: this.handleClick
      }, label, multi && this.state.cur ? /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-check"
      }) : '', this.props.removeAble ? /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-close",
        onClick: this.handleRemove
      }) : '');
    }
  }]);

  return Tag;
}(KZUIComponent);

Tag.defaultProps = {
  value: 0,
  // id
  label: 'Tag',
  // tag标签
  active: false,
  // 是否激活
  cancel: false,
  // 激活后是否可取消
  multi: false,
  // 多/单选
  disabled: false,
  // 是否禁用
  showOnly: false,
  // 是否为展示标签
  removeAble: false,
  // 是否可以删除
  onChange: null,
  onRemove: null,
  style: {},
  className: ''
};
Tag.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  active: PropTypes.bool,
  cancel: PropTypes.bool,
  multi: PropTypes.bool,
  disabled: PropTypes.bool,
  showOnly: PropTypes.bool,
  removeAble: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string
};
export default Tag;